<div class="container-fluid">
    <div class="row">
      <!-- Background section -->
      <div class="col-md-7 loginbglauditor" >
      </div>
      
      <!-- Login form section -->
      <div class="col-md-5">
        <!-- Logo area -->
        <div class="logomain">
          <ng-container>
            <!-- <img src="/assets/site/images/widlogo.png" class="loginlogo" alt="Lauditor Logo"> -->
            <div class="logotxt">  <img class="loginlogo" src="assets/dgc_fulllogo.png" alt="App Logo"> </div>
          </ng-container>
        </div>
        
        <!-- Login form -->
        <div class="loginform" *ngIf="showLoginForm">
          <!-- Error message display -->
          <div class="lblmsg" *ngIf="msg">
            <label id="id_alert" class="logininfo">{{msg}}</label>
          </div>
          
          <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
            <div class="signin">Login</div>
            
            <!-- Email field -->
            <div class="form-floating">
              <input formControlName="email"
                    class="form-control custominput"
                    id="id_email"
                    type="text"
                    placeholder="Email">
              <label for="id_email" class="lblfocus">Email</label>
              
              <div *ngIf="submitted && f['email'].errors" class="text-danger">
                <div class="errorStyle" *ngIf="f.email.errors.required">Email is required</div>
                <div class="errorStyle" *ngIf="f.email.errors.pattern">Email must be a valid email address.</div>
              </div>
            </div>
            
            <!-- Password field -->
            <div class="form-floating">
              <input formControlName="password"
                    class="form-control custominput"
                    [type]="showPassword ? 'text' : 'password'"
                    inputmode="password"
                    id="id_password"
                    placeholder="Password">
              <label for="id_password" class="lblfocus">Password</label>
              
              <!-- Toggle password visibility -->
              <img src="/assets/eye_open.svg"
                   class="viewpass"
                   *ngIf="showPassword"
                   (click)="showPassword = false"
                   alt="Hide password">
              <img src="/assets/eye_close.svg"
                   class="viewpass"
                   *ngIf="!showPassword"
                   (click)="showPassword = true"
                   alt="Show password">
              
              <!-- Password validation errors -->
              <div *ngIf="submitted && f['password'].errors" class="text-danger">
                <div class="errorStyle" *ngIf="f['password'].errors.required">Password is required</div>
                <div class="errorStyle" *ngIf="f['password'].errors.msg">{{f['password'].errors['msg']}}</div>
              </div>
              
              <!-- Forgot password link -->
              <div class="fpassword">
                <a href="javascript:void(0);"
                   class="fpass" 
                   (click)="forgotPwd()">Forgot Password</a>
              </div>
            </div>
            
            <!-- Login button -->
            <div class="btnlogin">
              <button type="submit" class="btnloginsubmit">Login</button>
            </div>
          </form>
        </div>
        
        <!-- Other components rendered conditionally -->
        <app-resetpwd *ngIf="showResetForm"
                      [parentData]="resetData"
                      (event)="onChildEvent($event)"></app-resetpwd>
        <app-forgotpwd *ngIf="showForgotForm"
                       (event)="onChildEvent($event)"></app-forgotpwd>
      </div>
    </div>
  </div>